import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BiPowerOff } from 'react-icons/bi';


export default function Logout() {
  const navigate = useNavigate();

  const handleClick = async () => {
    const confirmed = window.confirm('Do You Want To Logout?');

    if (confirmed) {
      localStorage.clear();
      navigate('/login');
      alert("Logged out Successfull!")
    }
  };



  return (
    <div>
      <Button onClick={handleClick}>
        <BiPowerOff />
      </Button>

    </div>
  );
}
const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #9a86f3;
  border: none;
  cursor: pointer;
  svg {
    font-size: 1.3rem;
    color: #ebe7ff;
  }
`;